import { create } from "zustand";

const useAdminStore = create((set, get) => ({
  isAdmin: false,
  setIsAdmin: () => set({ isAdmin: true }),
}));
export { useAdminStore };
